<template lang="html">
  <div class="cortina" :class="[show ? 'show' : '']"></div>
  <div
    :class="['modal-doc', show ? 'show' : '']"
    :style="{
      'background-image':
        'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url(' +
        coverImg +
        ')',
    }"
  >
    <div class="content">
      <div class="icon">
        <svg
          width="49"
          height="53"
          viewBox="0 0 49 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.2655 14.8076H8.08181C7.23439 14.8076 6.54736 15.4935 6.54736 16.3395C6.54736 17.1855 7.23439 17.8713 8.08181 17.8713H16.2655C17.1129 17.8713 17.8 17.1855 17.8 16.3395C17.8 15.4935 17.1129 14.8076 16.2655 14.8076Z"
            fill="url(#paint0_radial_2375_4024)"
            fill-opacity="0.97"
          />
          <path
            d="M16.2655 22.9775H8.08181C7.23439 22.9775 6.54736 23.6634 6.54736 24.5094C6.54736 25.3554 7.23439 26.0412 8.08181 26.0412H16.2655C17.1129 26.0412 17.8 25.3554 17.8 24.5094C17.8 23.6634 17.1129 22.9775 16.2655 22.9775Z"
            fill="url(#paint1_radial_2375_4024)"
            fill-opacity="0.97"
          />
          <path
            d="M16.2655 31.1475H8.08181C7.23439 31.1475 6.54736 31.8333 6.54736 32.6793C6.54736 33.5253 7.23439 34.2111 8.08181 34.2111H16.2655C17.1129 34.2111 17.8 33.5253 17.8 32.6793C17.8 31.8333 17.1129 31.1475 16.2655 31.1475Z"
            fill="url(#paint2_radial_2375_4024)"
            fill-opacity="0.97"
          />
          <path
            d="M38.2589 28.0765V14.0909C38.2589 12.072 37.4791 10.1673 36.0631 8.72672L29.8371 2.2992C29.8341 2.29613 29.8311 2.29297 29.8281 2.2899C28.3946 0.834651 26.4 0 24.3558 0H4.60334C2.06506 0 0 2.06156 0 4.59553V44.3214C0 46.8554 2.06506 48.9169 4.60334 48.9169H28.319C30.5057 51.0036 33.4677 52.287 36.7244 52.287C43.4932 52.287 49 46.8353 49 40.1343C49 33.9477 44.3061 28.8264 38.2589 28.0765ZM3.06889 44.3214V4.59553C3.06889 3.75088 3.75725 3.06369 4.60334 3.06369H24.3558C25.5807 3.06369 26.7759 3.56317 27.636 4.43398L33.8608 10.8605C33.8638 10.8635 33.8668 10.8666 33.8696 10.8696C34.7211 11.7342 35.19 12.8782 35.19 14.091V28.078C29.1993 28.8335 24.5511 33.9522 24.5511 40.1344C24.5511 42.2007 25.071 44.1479 25.9861 45.8533H4.60334C3.75725 45.8532 3.06889 45.166 3.06889 44.3214ZM36.7244 49.2233C31.7042 49.2233 27.62 45.146 27.62 40.1343C27.62 35.1227 31.7042 31.0454 36.7244 31.0454C41.801 31.0454 45.9311 35.1227 45.9311 40.1343C45.9311 45.146 41.801 49.2233 36.7244 49.2233Z"
            fill="url(#paint3_radial_2375_4024)"
            fill-opacity="0.97"
          />
          <path
            d="M40.2637 36.5063C39.6128 35.9649 38.6452 36.0527 38.1026 36.7025L35.5128 39.8051L34.9253 38.6321C34.5463 37.8754 33.6246 37.5685 32.8666 37.9471C32.1086 38.3253 31.8014 39.2456 32.1804 40.0022L33.8172 43.2701C34.0488 43.7326 34.4983 44.0471 35.0127 44.1067C35.0719 44.1135 35.1309 44.117 35.1898 44.117C35.642 44.117 36.075 43.9172 36.3684 43.5658L40.4603 38.6639C41.0027 38.0137 40.9148 37.0479 40.2637 36.5063Z"
            fill="url(#paint4_radial_2375_4024)"
            fill-opacity="0.97"
          />
          <path
            d="M24.449 17.8713H26.0857C26.9332 17.8713 27.6202 17.1855 27.6202 16.3395C27.6202 15.4935 26.9332 14.8076 26.0857 14.8076H24.449C23.6016 14.8076 22.9146 15.4935 22.9146 16.3395C22.9146 17.1855 23.6016 17.8713 24.449 17.8713Z"
            fill="url(#paint5_radial_2375_4024)"
            fill-opacity="0.97"
          />
          <path
            d="M27.6202 24.5094C27.6202 23.6634 26.9332 22.9775 26.0857 22.9775H24.449C23.6016 22.9775 22.9146 23.6634 22.9146 24.5094C22.9146 25.3554 23.6016 26.0412 24.449 26.0412H26.0857C26.9332 26.0412 27.6202 25.3554 27.6202 24.5094Z"
            fill="url(#paint6_radial_2375_4024)"
            fill-opacity="0.97"
          />
          <defs>
            <radialGradient
              id="paint0_radial_2375_4024"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(12.1737 15.7574) rotate(90) scale(2.11396 7.7643)"
            >
              <stop stop-color="#33647E" />
              <stop offset="1" stop-color="#013652" />
            </radialGradient>
            <radialGradient
              id="paint1_radial_2375_4024"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(12.1737 23.9273) rotate(90) scale(2.11396 7.7643)"
            >
              <stop stop-color="#33647E" />
              <stop offset="1" stop-color="#013652" />
            </radialGradient>
            <radialGradient
              id="paint2_radial_2375_4024"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(12.1737 32.0972) rotate(90) scale(2.11393 7.7643)"
            >
              <stop stop-color="#33647E" />
              <stop offset="1" stop-color="#013652" />
            </radialGradient>
            <radialGradient
              id="paint3_radial_2375_4024"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(24.5 16.209) rotate(90) scale(36.078 33.81)"
            >
              <stop stop-color="#33647E" />
              <stop offset="1" stop-color="#013652" />
            </radialGradient>
            <radialGradient
              id="paint4_radial_2375_4024"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(36.417 38.6207) rotate(90) scale(5.49626 6.07051)"
            >
              <stop stop-color="#33647E" />
              <stop offset="1" stop-color="#013652" />
            </radialGradient>
            <radialGradient
              id="paint5_radial_2375_4024"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(25.2674 15.7574) rotate(90) scale(2.11396 3.24689)"
            >
              <stop stop-color="#33647E" />
              <stop offset="1" stop-color="#013652" />
            </radialGradient>
            <radialGradient
              id="paint6_radial_2375_4024"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(25.2674 23.9273) rotate(90) scale(2.11396 3.24689)"
            >
              <stop stop-color="#33647E" />
              <stop offset="1" stop-color="#013652" />
            </radialGradient>
          </defs>
        </svg>
      </div>
      <h6 class="title">{{ title }}</h6>
      <p class="description">{{ description }}</p>
      <div class="buttons">
        <Button variant="secondary" @click="closeModal">Cerrar</Button>
        <router-link to="/">
          <Button @click="eventSuccess">{{ action }}</Button>
        </router-link>
      </div>
    </div>
    <span v-if="!coverImg" class="watermark">
      <svg
        width="552"
        height="371"
        viewBox="0 0 552 371"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.1"
          d="M321.233 422.237C323.331 420.334 323.945 415.952 321.28 413.015C316.712 407.98 311.716 411.748 311.257 412.929C293.138 430.899 275.757 433.665 258.843 426.827C241.929 419.989 234.012 409.578 222.21 396.571C208.505 381.466 192.018 365.825 191.964 342.159C191.592 333.317 194.576 321.429 205.562 309.931C216.549 298.432 229.556 286.63 237.528 279.397L273.611 246.657C278.646 242.088 284.139 236.339 288.102 237.334C292.064 238.328 297.394 244.202 303.104 250.496C313.383 261.824 337.826 287.077 344.981 296.649C351.376 305.382 352.207 313.043 351.018 321.007C349.448 328.551 345.213 333.159 342.696 335.443C341.437 336.585 336.822 340.773 334.724 342.676C332.168 345.761 333.955 350.259 335.858 352.357C338.142 354.875 342.944 355.108 345.5 352.023C349.735 347.416 350.193 346.235 353.55 343.19C367.015 330.207 377.466 321.49 394.854 310.302C401.909 305.431 410.029 303.419 408.739 296.939C408.397 295.719 407.069 290.039 400.589 291.329C393.728 292.199 386.526 291.849 377.537 287C369.348 282.19 358.727 269.642 353.778 264.188C352.255 262.509 324.844 232.3 314.566 220.972C313.804 220.132 311.481 218.415 312.056 214.834C312.251 210.832 315.149 208.967 316.827 207.445L409.133 123.691C412.07 121.026 413.329 119.884 416.95 119.658C417.75 119.697 420.493 121.034 422.015 122.712C426.964 128.167 437.663 139.114 448.322 150.862C463.931 168.065 481.824 187.785 494.007 201.211C502.001 210.022 502.871 216.883 502.599 222.485C502.094 232.888 496.981 239.057 494.044 241.722C489.848 245.529 482.716 252.001 478.061 256.989C474.246 261.216 476.072 264.914 477.595 266.592C480.641 269.949 484.681 269.343 486.359 267.82C488.877 265.536 490.174 263.594 496.048 258.264C504.479 249.85 514.509 241.513 517.446 238.848C527.477 230.512 538.689 222.634 549.062 215.517C552.38 213.272 552.652 207.67 549.567 205.113C544.199 200.04 536.048 194.43 532.964 191.873C510.611 173.14 493.324 157.46 473.108 136.023C452.512 114.166 431.573 91.0899 410.596 68.8136C390.038 46.1566 369.519 22.6993 349.381 -0.338337C330.004 -22.5369 316.073 -41.2622 299.595 -65.3254C297.349 -68.6431 291.756 -77.3375 288.026 -83.1338C285.781 -86.4515 280.179 -86.7236 277.623 -83.6391C269.915 -73.5854 260.607 -63.6095 251.337 -54.4338C248.4 -51.7689 239.131 -42.5933 229.939 -35.0181C224.484 -30.069 222.006 -28.5851 219.488 -26.3009C217.81 -24.7781 217.196 -20.396 219.861 -17.459C221.384 -15.7807 225.688 -13.5662 229.464 -16.9925C234.88 -21.1413 241.632 -28.0328 246.208 -31.4203C249.145 -34.0852 255.781 -38.5758 266.184 -38.0704C271.786 -37.7983 278.53 -36.2675 286.525 -27.4564C298.707 -14.0301 316.22 5.27031 332.209 22.8924C342.869 34.6405 353.528 46.3885 358.058 52.2237C359.581 53.902 360.264 56.3417 360.606 57.5615C360.451 60.7626 358.772 62.2854 355.835 64.9503L263.529 148.704C261.851 150.227 259.294 153.312 255.713 152.737C252.092 152.962 250.608 150.483 249.847 149.644C239.568 138.316 211.777 107.687 210.254 106.008C205.305 100.554 193.806 89.5673 189.851 80.1503C185.897 70.7334 185.827 63.9116 187.778 56.7869C189.27 50.8431 183.784 48.1702 182.984 48.1313C176.24 46.6005 173.451 54.4866 168.338 60.6556C155.517 76.8782 146.248 86.0539 131.602 98.5781C128.245 101.624 127.025 101.966 122.029 105.734C118.712 107.979 118.478 112.781 120.763 115.298C122.666 117.396 126.97 119.61 130.288 117.365C132.386 115.462 137.001 111.274 138.26 110.132C140.777 107.848 145.354 104.46 153.434 103.248C161.515 102.037 169.44 104.026 177.093 111.617C185.926 119.667 208.691 146.442 219.35 158.19C225.061 164.483 230.391 170.357 230.997 174.398C231.603 178.438 225.348 183.348 220.313 187.916L184.23 220.657C175.838 228.271 163.251 239.692 150.741 249.512C138.651 258.952 126.531 260.77 117.347 259.922C93.7973 257.575 79.4473 239.231 65.7421 224.126C54.3211 211.539 44.3452 202.23 39.1789 184.733C33.9737 168.036 38.03 150.585 58.0918 133.912C59.3506 132.77 63.1656 128.543 58.9779 123.928C56.313 120.991 51.892 121.178 49.7942 123.081C44.7981 126.849 34.3477 135.566 20.3463 151.331C18.668 152.853 10.121 163.668 4.89174 172.238C0.960092 178.866 0.34618 183.248 0.0351839 189.65C-0.0117138 198.872 5.65988 205.966 8.32478 208.903C20.5072 222.33 54.0088 259.252 74.5666 281.909C89.4139 298.273 119.87 331.839 119.87 331.839C119.87 331.839 149.945 364.985 164.793 381.348C185.35 404.005 218.852 440.928 231.034 454.354C233.699 457.291 240.21 463.624 249.394 464.471C256.177 465.201 260.217 464.595 267.194 461.325C276.23 456.951 287.442 449.072 289.501 447.969C307.31 436.401 316.618 426.425 321.233 422.237Z"
          fill="#33647E"
          fill-opacity="0.8"
        />
      </svg>
    </span>
  </div>
</template>
<script>
import Button from "../General/Button.vue";

export default {
  emits: ["updateShow"],
  components: {
    Button,
  },
  props: {
    title: String,
    description: String,
    show: {
      type: Boolean,
      default: false,
    },
    coverImg: String,
    eventSuccess: {
      type: Function,
    },
    action: String,
  },
  methods: {
    closeModal() {
      this.$emit("updateShow", false);
    },
  },
};
</script>
<style lang="css" scoped>
.cortina {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  display: none;
}
.cortina.show {
  display: block;
}
.modal-doc {
  width: 760px;
  background: #ffffff;
  background-size: cover;
  border-radius: 8px;
  padding: 56px;
  box-shadow: 2px 2px 20px #07193117;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  display: none;
  z-index: 1100;
}
.modal-doc.show {
  display: block;
}
.modal-doc .content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 2;
}
.modal-doc .content .icon {
  margin-bottom: 22px;
}
.modal-doc .content .title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 37px;
  color: #013652;
  margin-bottom: 12px;
}
.modal-doc .content .description {
  max-width: 410px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #696f72;
  text-align: center;
  margin-bottom: 48px;
}
.modal-doc .content .buttons {
  display: flex;
  column-gap: 10px;
}
.modal-doc .watermark {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}
</style>
